import { mergeObjectTypes } from '../cacheHelpers';

const Summary = {
  merge: mergeObjectTypes
};

export default Summary;
